<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('employeeProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('employeeProfile.pageTitle'),
            href: '/admin/employees',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-3">
          <Photo v-model="model" :validate="errors" />
        </div>
        <div class="col-md-9">
          <ts-card>
            <ts-card-wrapper>
              <Employment v-model="model" :validate="errors" />
              <Address v-model="model" :validate="errors" class="ts-mt-4" />
              <SocialSecurityNumber v-model="model" :validate="errors" class="ts-mt-4" />
              <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <div class="row">
                    <label class="col-md-4"></label>
                    <div class="col-md-7 ts-w-full ts-flex ts-justify-end ts-space-x-4 ts-mt-4">
                      <ts-button
                        @click.prevent="$router.push({ name: 'em-profile' })"
                      >{{ $t('cancel') }}</ts-button>
                      <ts-button
                        color="primary"
                        outline
                        :waiting="waiting_new"
                        @click.prevent="saveAddNew"
                      >{{ $t('save_add_new') }}</ts-button>
                      <ts-button
                        color="primary"
                        :waiting="waiting"
                        @click.prevent="save"
                      >{{ $t('save') }}</ts-button>
                    </div>
                  </div>
                </div>
              </div>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import Photo from './components/photo'
import Employment from './components/employment'
import Address from './components/address'
import SocialSecurityNumber from './components/socail-security-number'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'employeeProfile',
  components: {
    Photo,
    Employment,
    Address,
    SocialSecurityNumber
  },
  data() {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
			errors: new Errors(),
			file: null,
      model: {
        employee_id: 0,
        card_id: null,
        employee_name_kh: null,
        employee_name_en: null,
        sex: 'male',
        phone: null,
        email: null,
        address: null,
        photo: null,
        employment_date: moment().format('DD-MM-YYYY'),
        probation_end_date: null,
        position_id: null,
        department_id: null,
        status_id: 1,
        status_effective_date: null,
        nationality: null,
        ssn_no: null,
        ssn_issued_date: null,
        ssn_expiry_date: null,
        ssn_issued_at: null,
        date_of_birth: null
      }
    }
  },
  methods: {
    ...mapActions('employee/profile', ['position', 'department', 'store', 'upload']),
    async fetchData() {
      this.loading = true
      await this.position()
      await this.department()
      this.loading = false
		},
		async uploadPhoto(id){
			if((this.file instanceof File) || this.file instanceof Blob){
				let formData = new FormData()
        formData.append('photo', this.file)
        let response = await this.upload({
					id: id,
					data: formData
				})
			}
		},
    save() {
			let { photo, ...dataSend } = this.model
			this.file = photo
			this.waiting = true
			this.errors = new Errors()
      this.store(dataSend)
        .then(async response => {
					await this.uploadPhoto(response.id)
					this.$toasted.success(response.message)
					this.$router.push({ name: 'em-profile'})
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
		saveAddNew() {
			let { photo, ...dataSend } = this.model
			this.file = photo
			this.waiting_new = true
			this.errors = new Errors()
      this.store(dataSend)
        .then(async response => {
					await this.uploadPhoto(response.id)
					this.$toasted.success(response.message)
					this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
		},
		clearInput(){
			this.model.employee_id = 0
      this.model.card_id = null
      this.model.employee_name_kh = null
      this.model.employee_name_en = null
      this.model.sex = 'male'
      this.model.phone = null
      this.model.email = null
      this.model.address = null
      this.model.photo = null
      this.model.employment_date = null
      this.model.probation_end_date = null
      this.model.position_id = null
      this.model.department_id = null
      this.model.status_id = 1
      this.model.status_effective_date = null
      this.model.nationality = null
      this.model.ssn_no = null
      this.model.ssn_issued_date = null
      this.model.ssn_expiry_date = null
      this.model.ssn_issued_at = null
			this.model.date_of_birth = null
			this.file = null
			this.errors = new Errors()
		}
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('employee/profile/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>